export const getTableBodyHeight = (otherHeight=200, skipHeight=20)=> window.innerHeight - otherHeight - skipHeight;

export const getLimit = (othersHeight=272, itemHeight=50)=> {
    const tableBodyHeight = window.innerHeight - othersHeight;
    return Math.floor(tableBodyHeight/itemHeight);
}